module.exports = __webpack_public_path__ + "static/img/inbox.dca66f6b.svg";